/* eslint-disable no-restricted-syntax */
import { useRouterState } from 'app/hooks/useRouterState';

type TQueryParamKeys = 'promo_code' | 'period' | 'payment' | 'filter_tag'
type THistoryState = null | {};

/**
 * @param {Object} queryParams <TQueryParamKeys, string>
 * @param {Object} state
 * @description Ставит значния query params в URL
 */

const mapQueryParams = (props: Record<TQueryParamKeys, string>, search: string) => {
    const params = new URLSearchParams(search);
    // const hashParams = new URLSearchParams(window.location.hash);
    for (const [key, value] of Object.entries(props)) {
        if (!value) {
            params.delete(key);
        } else {
            params.set(key, value);
        }
    }
    return params;
};

export function URLUpdater(
    props: Record<TQueryParamKeys, string>,
    state: THistoryState = null,
) {
    const params = mapQueryParams(props, window.location.search);
    // console.log(params.toString());
    // console.log('Updated:', params.toString());
    window.history.replaceState(state, '', `?${params.toString()}${window.location.hash}`);
}

// FOR REACT ROUTER
export function useURLUpdater() {
    const [{ history }] = useRouterState();

    const { location } = window;

    return (
        props: Record<string, string>,
        state: any = null,
        replace: boolean = true,
    ) => {
        const params = mapQueryParams(props, location.search);

        const queryString = params.toString();
        const newUrl = location.pathname
            + (queryString ? `?${queryString}` : '')
            + location.hash;

        if (replace) {
            history.replace(newUrl, state);
        } else {
            history.push(newUrl, state);
        }
    };
}
